<template>
    <div class="relative w-full">
        <product-renderer-wrapper
            :show-toolbar="false"
            :image-zoom-percent="135"
            class="h-[200px] bg-gray-F0F0F0"
        />
        <div class="absolute flex justify-end items-center bottom-[16px] right-[31px] w-full lg:hidden">
            <button
                type="button"
                class="focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2"
                :aria-label="$t('PREVIEW')"
                @click="openPreviewPanel"
            >
                <img
                    src="../assets/images/icons/expand.svg"
                    width="24"
                    height="24"
                    alt=""
                >
            </button>
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import ProductRendererWrapper from './ProductRendererWrapper.vue';

    export default {
        mixins: [allStores],

        components: {
            ProductRendererWrapper,
        },

        methods: {
            openPreviewPanel() {
                this.appStore.openNestedPanel('preview-panel');
            },
        },
    };
</script>
